// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div#_pg-app{padding:0!important}.link,.st-link{cursor:pointer}.st-link{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
